import type { MetaFunction } from 'react-router';
import type { ListItem } from 'schema-dts';
import type { loader as productsLoader } from '~/routes/_app.products.$';
import { constructProductSchema } from './product-schema';
import { getMetaBaseUrl } from '../util/create-meta-base-url';
import type { StaticParentLoaders } from '../util';

export const createProductsItemListSchema: MetaFunction<
    typeof productsLoader,
    StaticParentLoaders
> = (props) => {
    if (!props.data) {
        return [];
    }
    const { data, location } = props;
    const baseUrl = getMetaBaseUrl(props);
    const itemListElement: ListItem[] = props?.data.productTilesRocco?.map(
        ({ model }, idx) => {
            return {
                '@type': 'ListItem',
                position: data.pagination?.currentRange?.from + idx,
                item: {
                    ...constructProductSchema({
                        id: model.id,
                        title: model.title,
                        description: model.seoDescription,
                        url: baseUrl + model.link,
                        image: model.images?.[0]?.src ?? '',
                        professionalName: model.professional.name,
                        hasPrice: !!model.price?.amount,
                        price: {
                            price: model.price?.amount
                                ? model.price.amount.toString()
                                : '0.00',
                        },
                        variantCount: model.variants?.length || 1,
                        priceCurrency: model.price?.currency ?? 'NZD', // add to ES pricing
                    }),
                },
            };
        },
    );
    return [
        {
            '@type': 'ItemList',
            url: baseUrl + location.pathname,
            numberOfItems: data.searchResult?.nbHits,
            itemListElement,
        },
    ];
};
